export default "__VITE_ASSET__CtS2CFFn__"